// api/system/dict.js
import request from '@/utils/request'

// 获取字典类型列表
export function getTypes() {
  return request({
    url: '/dictionary/types',
    method: 'get'
  })
}

// 创建字典类型
export function createType(data) {
  return request({
    url: '/dictionary/types',
    method: 'post',
    data
  })
}

// 删除字典类型
export function deleteType(id) {
  return request({
    url: `/dictionary/types/${id}`,
    method: 'delete'
  })
}

// 分页获取字典项列表
export function getPageList(params) {
  return request({
    url: '/dictionary/page',
    method: 'get',
    params
  })
}

// 根据类型获取字典项（用于其他地方，比如下拉框）
export function getItemsByType(typeCode) {
  return request({
    url: `/dictionary/types/${typeCode}/items`,
    method: 'get'
  })
}

// 创建字典项
export function createItem(data) {
  return request({
    url: '/dictionary/items',
    method: 'post',
    data
  })
}

// 更新字典项
export function updateItem(id, data) {
  return request({
    url: `/dictionary/items/${id}`,
    method: 'put',
    data
  })
}

// 删除字典项
export function deleteItem(id) {
  return request({
    url: `/dictionary/items/${id}`,
    method: 'delete'
  })
}